import { AxiosInstance, CancelToken } from "axios";
import { BlogPost } from "@/types/blog-post.interface";

export class BlogApi {
  constructor(protected axios: AxiosInstance) {}

  getPosts(cancelToken?: CancelToken): Promise<BlogPost[]> {
    return this.axios
      .get<BlogPost[]>(`/api/blog/posts`, {
        cancelToken,
      })
      .then((r) => r.data);
  }
}
